module.exports = __webpack_public_path__ + "static/media/pablo-gonzalez-santa-reliquia-virgen-coromoto.492b6df3.png";